// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aK","header":"aL","title":"aM","subHeader":"aN","footer":"aO"};